/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tax, Loadable, idle, LoadableStatus, TaxesSummary } from '@card/types';
import { TaxesAction, TaxesActionType } from './actions';

export interface TaxesState {
  taxes: Loadable<TaxesSummary>;
}

const INITIAL_STATE: TaxesState = {
  taxes: idle()
};

export const groupBy = (
  list: any[],
  keyGetter: { (tax: { categories: any[] }): any; (arg0: any): string | number }
) => {
  return list.reduce((acc, element) => {
    const currentKeyList = acc[keyGetter(element)] || [];
    currentKeyList.push(element);
    acc[keyGetter(element)] = currentKeyList;
    return acc;
  }, {});
};

const CATEGORY_REGEX = /ingresos brutos/i;
function processTaxesfromAPI(taxes: Tax[]): TaxesSummary {
  // 1
  taxes = taxes.map((tax) => {
    if (Object.keys(tax['regions']).length === 0 || !tax['categories'][2].match(CATEGORY_REGEX)) {
      delete tax['regions'];
    }
    return tax;
  });
  // 2
  const groupedTaxes = groupBy(taxes, (tax: { categories: any[] }) => tax.categories[1]);
  return groupedTaxes;
}

export function taxesReducer(state = INITIAL_STATE, action: TaxesAction): TaxesState {
  switch (action.type) {
    case TaxesActionType.FetchStarted:
      return { ...state, taxes: { ...state.taxes, status: LoadableStatus.Fetching } };
    case TaxesActionType.FetchSuccess:
      return {
        ...state,
        taxes: { data: processTaxesfromAPI(action.payload), status: LoadableStatus.Fetched }
      };
    case TaxesActionType.FetchError:
      return {
        ...state,
        taxes: { ...state.taxes, error: action.payload, status: LoadableStatus.Error }
      };
    default:
      return state;
  }
}
